import $ from 'jquery';
import 'bootstrap';
/*import '../theme/js/datatable/datatables/jquery.dataTables.min.js'*/

/*import 'datatables.net-bs4'; // Основной модуль DataTables с поддержкой Bootstrap 4*/
/*import 'datatables.net-responsive-bs4'; // Дополнительный модуль для респонсивности*/
/*import 'datatables.net-buttons-bs4'; // Модуль для поддержки кнопок*/

/*import '../theme/js/datatable/datatables/jquery.dataTables.min.js'
import '../theme/js/datatable/datatable-extension/dataTables.responsive.min.js';
import '../theme/js/datatable/datatable-extension/responsive.bootstrap4.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.buttons.min.js';
import '../theme/js/datatable/datatable-extension/jszip.min.js';
import '../theme/js/datatable/datatable-extension/buttons.colVis.min.js';
import '../theme/js/datatable/datatable-extension/pdfmake.min.js';
import '../theme/js/datatable/datatable-extension/vfs_fonts.js';
import '../theme/js/datatable/datatable-extension/dataTables.autoFill.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.select.min.js';
import '../theme/js/datatable/datatable-extension/buttons.bootstrap4.min.js';
import '../theme/js/datatable/datatable-extension/buttons.html5.min.js';
import '../theme/js/datatable/datatable-extension/buttons.print.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.keyTable.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.colReorder.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.fixedHeader.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.rowReorder.min.js';
import '../theme/js/datatable/datatable-extension/dataTables.scroller.min.js';*/

/*import 'bootstrap';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-autofill-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-keytable-bs5';
import 'datatables.net-colreorder-bs5';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-rowreorder-bs5';
import 'datatables.net-scroller-bs5';
import 'jszip';
import 'pdfmake';*/
import 'bootstrap-notify';

window.$ = window.jQuery = $;
